import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ScreeningGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkScreeningStatus = () => {
      const hasCompletedScreening = localStorage.getItem('hasCompletedScreening');
      
      if (!hasCompletedScreening && location.pathname !== '/screening') {
        navigate('/screening', { replace: true });
      } else if (hasCompletedScreening && location.pathname === '/screening') {
        navigate('/', { replace: true });
      }
      
      setIsChecking(false);
    };

    checkScreeningStatus();
  }, [navigate, location.pathname]);

  if (isChecking) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #488ce6ff 0%, #8db5e6ff 100%)'
      }}>
        <div style={{
          textAlign: 'center',
          color: 'white'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid rgba(255,255,255,0.3)',
            borderTop: '4px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>Loading CDAP...</p>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      </div>
    );
  }

  return children;
};

export default ScreeningGuard;